import { AttoPignoramnetoDTO } from "./atto-pignoramento-dto";
import { BonificoDTO } from "./bonifico-dto";
import { BonificoExtraSepaDTO } from "./bonifico-extra-sepa-dto";
import { TesoreriaDTO } from "./tesoreria-dto";
import { VagliaBdiDTO } from "./vaglia-bdi-d-t-o";

export class PagamentoDTO {
	idModalitaPagamento: string;
	tipoPagamento: string;
	bonifico: BonificoDTO;
	tesoreria: TesoreriaDTO;
	bonificoExtraSepa: BonificoExtraSepaDTO;
	vagliaBDI: VagliaBdiDTO;
	tribunale: AttoPignoramnetoDTO;
}